
export default function Register({ submitReg }) {
  return (
    <div className="form">
      <p className="enter">ENTER YOUR USERNAME AND PASSWORD</p>
      <form onSubmit={submitReg}>
        <div className="formdata">
          <div>
            <p>NAME</p>
            <p>SURNAME</p>
            <p>USERNAME</p>
            <p>EMAIL</p>
            <p>OWN PHONE NUMBER</p>
            <p>WORK PHONE NUMBER</p>
            <p>PASSWORD</p>
            <p>MYEREVAN PASSWORD</p>
            <p>ARE YOU MANAGER?</p>
          </div>
          <div className="inputs">
            <input type="text" name="name" />
            <input type="text" name="surName" />
            <input type="text" name="userName" />
            <input type="text" name="email" />
            <input type="tel" name="ownPhoneNumber" />
            <input type="tel" name="workPhoneNumber" />
            <input type="password" name="password" />
            <input type="password" name="myErevanPassword" />
            <input className="managerOrNot" type="checkbox" name="isManager" />
          </div>
        </div>
        <input className="formsub" type="submit" />
      </form>
    </div>
  );
}
